import { TimeIcon } from "../Assets/assets";
import Button from "../Components/Button/Button";
import Header from "../Components/Header/Header";
import { isValidArray, isValidObject } from "../Services/validators";

export const Regex = {
  pinCode: /^[1-9][0-9]{5}$/gm,
  aadhaarNumber: /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
  phoneNumber: /^[6-9]\d{9}$/,
  healthId: /^(?=[a-zA-Z])([a-zA-Z0-9]){2,13}[a-zA-Z]$/i,
  // eslint-disable-next-line
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
};

export const isLocalHost = () => {
  return (
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname === "[::1]" ||
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(
        window.location.hostname
      )) &&
    process.env.NODE_ENV !== "production"
  );
};

export function rippleEffect(event) {
  const parentElement = event.currentTarget;
  const containerElement = event.currentTarget.parentElement;
  const viewportOffset = parentElement.getBoundingClientRect();
  parentElement.classList.add("ripple-element");

  const circle = document.createElement("span");
  circle.classList.add("ripple-span");
  const diameter = Math.max(
    parentElement.clientWidth,
    parentElement.clientHeight
  );
  const radius = diameter / 2;

  circle.style.width = circle.style.height = `${diameter}px`;
  circle.style.left = `${
    event.clientX +
    containerElement.scrollLeft -
    parentElement.offsetLeft -
    radius
  }px`;
  circle.style.top = `${
    event.clientY + containerElement.scrollTop - viewportOffset.y - radius
  }px`;
  circle.classList.add("ripples");

  const ripple = parentElement.getElementsByClassName("ripples")[0];

  if (ripple) {
    ripple.remove();
  }
  //Add ripple element
  parentElement.appendChild(circle);
}

export function dateAndTimeConverter(timestamp, type) {
  if (!timestamp) return;

  if (type === "cardDate") {
    let dateObject = new Date(timestamp);
    const date =
      dateObject.toLocaleString("en-IN", { day: "numeric" }) +
      " " +
      dateObject.toLocaleString("en-IN", { month: "short" });

    return date;
  } else {
    if (type === "firstDate") {
      let dateObject = new Date(timestamp);
      const date = dateObject
        .toLocaleString("en-IN", { day: "numeric" })
        .toUpperCase();
      return date;
    }
    if (type === "secondDate") {
      let dateObject = new Date(timestamp);
      const date =
        dateObject.toLocaleString("en-IN", { day: "numeric" }).toUpperCase() +
        " " +
        dateObject.toLocaleString("en-IN", { month: "short" }).toUpperCase() +
        " " +
        dateObject.toLocaleString("en-IN", { year: "numeric" });
      return date;
    }
  }

  if (type === "Time") {
    let dateObject = new Date(timestamp);
    const date = dateObject
      .toLocaleString("en-IN", {
        hour: "numeric" && "2-digit",
        minute: "numeric" && "2-digit",
        hour12: true
      })
      .toUpperCase();

    // + " ";
    return date;
  }
}

export const locationRange = 500; //meters
export const movePerSecond = 5; //meters
export const liveLocationUpdateTime = 5; //seconds

export function calculateDistance(location1, location2) {
  const deg2rad = (deg) => deg * (Math.PI / 180);

  if (location1 && location2) {
    const R = 6371; // Radius of the earth in kilometers
    const dLat = deg2rad(location2.latitude - location1.latitude);
    const dLon = deg2rad(location2.longitude - location1.longitude);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(location1.latitude)) *
        Math.cos(deg2rad(location2.latitude)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = Math.round(R * c * 1000); // Distance in meters

    return distance;
  } else {
    return null;
  }
}

export const getAppsUrls = {
  admin: { title: "Admin Panel", key: "admin", url: process.env.REACT_APP_ADMIN_URL },
  public: { title: "Public App", key: "public", url: process.env.REACT_APP_PUBLIC_URL },
  employees: {
    title: "Employee App",
    key: "employees",
    url: process.env.REACT_APP_EMPLOYEES_URL
  },
  support: {
    title: "Customer support App",
    key: "support",
    url: process.env.REACT_APP_SUPPORT_URL
  }
};

export const complaintsCategory = [
  "Restroom is not open",
  "No water supply",
  "Lights not working",
  "Waterlogged in the drainage",
  "Broken doors, latches",
  "Lack of security measures",
  "Janitors are not on duty",
  "Unsanitary restroom",
  "Fees are charged",
  "Unhygienic environment"
];

export const complaintsQueryPath = {
  status: "status.currentStatus",
  issueRaised: "issuedBy.userDetails.phoneNumber",
  issueTakenByPhoneNumber: "takenOverBy.phoneNumber",
  issueTakenByEmail: "takenOverBy.email",
  category: "category",
  ward: "location.ward",
  zone: "location.zone",
  dateRange: "createdAt",
  PCTNo: "location.id"
};

export function isValidDate(dateString) {
  const regex = /^[1-9]\d{3}-\d{2}-\d{2}$/;
  if (!regex.test(dateString)) {
    return false;
  }

  const [year, month, day] = dateString.split("-").map(Number);
  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
}

export function convertTimestampToTimer(timestamp, complaintClosed) {
  const positiveTimestamp = Math.abs(timestamp);

  const isNegative = timestamp <= 0;

  let seconds = Math.floor(positiveTimestamp / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  let days = Math.floor(hours / 24);

  seconds %= 60;
  minutes %= 60;
  hours %= 24;

  const pad = (num) => String(num).padStart(2, "0");

  return (
    <div
      className=" display-flex flex-align-items-center"
      style={{
        ...(isNegative ? { color: "red" } : {}),
        ...(!isNegative && complaintClosed ? { color: "#00892F" } : {})
      }}
    >
      <TimeIcon
        color={isNegative ? "red" : null}
        showTime={complaintClosed && isNegative ? false : true}
      />
      <div className=" padding-left-small">
        {complaintClosed && !isNegative
          ? "On time"
          : days
          ? `${isNegative ? "-" : ""} ${pad(days)}D : ${pad(hours)}H`
          : `${isNegative ? "-" : ""} ${pad(hours)}H : ${pad(minutes)}M`}
      </div>
    </div>
  );
}

export function getRemainingTime(turnaround, closedAt) {
  return closedAt ? turnaround - closedAt : turnaround - +new Date();
}

export const ieComplaintCategories = [
  "Attending to water stoppages in pipelines - whole or part of the system Water Shortage",
  "Attending to pipe rupture - isolated or whole system",
  "Attending to sewage block - isolated or whole system",
  "Attending to manpower absence -primary level, for field level activities",
  "Attending to plumbing faults - taps, tubes, and such fitments",
  "Attending to any defects /deficiencies in civil and/or electrical aspects of the Project Facilities",
  "Alternative arrangements for absence of supervisory staff for more than a day",
  "Attending to User complaints behind cleanliness/hygiene/safety deficiencies",
  "Attending to User complaints behind water/electricity/plumbing deficiencies",
  "Responding to report of Inspection team",
  "Removal of unauthorised handbills/posters/sign boards/stickers etc",
  "Attending to damages to signage's",
  "Removal / addressing restrictions of any nature whatsoever behind access to the facility",
  "Removing of cobwebs, dusting, water washing, attending to air purifiers and such other fitments for regular upkeep of the Facilities",
  "Attending to faults/ deficiencies in functioning of the Control room - CCMS",
  "Deficiencies in conducting ICE programs and activities",
  "Replacement of any lost/stolen/damaged asset created/provided for in the PCT",
  "Maintenance of Greenery in /surrounding toilet premises",
  "Non-Functionality of Sanitary napkin vending machine and safe disposal systems"
];

export const alignPhoneNumber = (phoneNumber) => {
  if (phoneNumber?.includes(+91)) {
    const num = phoneNumber.slice(3);
    return num.slice(0, 5) + " " + num.slice(5);
  } else if (phoneNumber) {
    return phoneNumber.slice(0, 5) + " " + phoneNumber.slice(5);
  }
};

export const PermissionDeniedFallback = (props) => {
  // for iphone only
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    props.onEnableClick();
  }
  return (
    <div className="inherit-parent-width inherit-parent-height">
      {!props.hideHeader && (
        <Header
          title="Raise Complaints"
          backOnClick={() => {
            props.navigate("/locationSearch");
          }}
          profileOnClick={props.profileOnClick}
        />
      )}

      <div
        className="remaining-body-height padding-large display-flex flex-direction-column flex-justify-content-center flex-align-items-center"
        data-cy="location-permission-denied-fallback"
      >
        <div className="inherit-parent-height padding-horizontal-large display-flex flex-direction-column flex-justify-content-center flex-align-items-center">
          <div>{props.fallBackImage}</div>
          <div className=" padding-top-larger font-family-RHD-medium">
            {props.title}
          </div>
          <div className=" padding-top-medium text-align-center font-size-medium">
            {props.description}
          </div>
        </div>
        {props.showButton && (
          <div className="inherit-parent-width padding-top-larger">
            <Button
              text="Enable"
              boxShadow={false}
              disabled={/iPhone|iPad|iPod/i.test(navigator.userAgent)}
              onClick={props.onEnableClick}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export const LocationFallBack = () => {
  return (
    <svg width="94" height="96" viewBox="0 0 94 96" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.7445 51.7583C52.6989 51.7583 55.9046 48.457 55.9046 44.3847C55.9046 40.3123 52.6989 37.0111 48.7445 37.0111C44.79 37.0111 41.5843 40.3123 41.5843 44.3847C41.5843 48.457 44.79 51.7583 48.7445 51.7583ZM48.7445 54.2162C54.017 54.2162 58.2913 49.8145 58.2913 44.3847C58.2913 38.9549 54.017 34.5532 48.7445 34.5532C43.4719 34.5532 39.1976 38.9549 39.1976 44.3847C39.1976 49.8145 43.4719 54.2162 48.7445 54.2162Z"
        fill="#C2C2C2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9556 92.006C28.0901 92.2723 29.6528 92.5222 31.5761 92.7396C35.9478 93.2337 42.0183 93.5421 48.7445 93.5421C55.4706 93.5421 61.5411 93.2337 65.9128 92.7396C67.8361 92.5222 69.3988 92.2723 70.5333 92.006C69.3988 91.7396 67.8361 91.4897 65.9128 91.2723C61.5411 90.7782 55.4706 90.4698 48.7445 90.4698C42.0183 90.4698 35.9478 90.7782 31.5761 91.2723C29.6528 91.4897 28.0901 91.7396 26.9556 92.006ZM31.3157 88.8291C35.7981 88.3225 41.9596 88.0119 48.7445 88.0119C55.5293 88.0119 61.6908 88.3225 66.1732 88.8291C68.4067 89.0816 70.2647 89.3871 71.5856 89.7401C72.2365 89.9141 72.8248 90.1168 73.2754 90.3657C73.4994 90.4894 73.7499 90.6571 73.9579 90.8886C74.1715 91.1263 74.4017 91.5046 74.4017 92.006C74.4017 92.5073 74.1715 92.8857 73.9579 93.1233C73.7499 93.3548 73.4994 93.5225 73.2754 93.6462C72.8248 93.8951 72.2365 94.0979 71.5856 94.2718C70.2647 94.6248 68.4067 94.9303 66.1732 95.1828C61.6908 95.6894 55.5293 96 48.7445 96C41.9596 96 35.7981 95.6894 31.3157 95.1828C29.0822 94.9303 27.2242 94.6248 25.9033 94.2718C25.2524 94.0979 24.6641 93.8951 24.2135 93.6462C23.9895 93.5225 23.739 93.3548 23.531 93.1233C23.3174 92.8857 23.0872 92.5073 23.0872 92.006C23.0872 91.5046 23.3174 91.1263 23.531 90.8886C23.739 90.6571 23.9895 90.4894 24.2135 90.3657C24.6641 90.1168 25.2524 89.9141 25.9033 89.7401C27.2242 89.3871 29.0822 89.0816 31.3157 88.8291Z"
        fill="#C2C2C2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.9217 18.6408C53.3444 14.4762 43.9522 14.244 36.7764 18.8617C25.9408 25.8347 21.9806 37.5834 23.8208 46.9053C25.0404 53.0838 27.9384 58.1195 32.3276 63.278C36.058 67.6622 40.8099 72.075 46.4769 77.3375C47.2558 78.0609 48.0521 78.8003 48.8653 79.5579C50.4686 77.9137 51.9899 76.3732 53.4359 74.9088C60.6994 67.5533 66.0632 62.1216 70.3756 55.1476C73.0856 50.7649 74.7225 45.7327 74.6076 40.6342C74.4978 35.7593 73.3431 31.5272 71.1122 27.8987C68.8796 24.2673 65.527 21.1721 60.9217 18.6408ZM35.5116 16.7774C43.5165 11.6261 53.8305 11.9573 62.0455 16.4725C66.944 19.1648 70.6358 22.5291 73.1287 26.5839C75.6234 30.6415 76.8753 35.3222 76.9937 40.5772C77.1216 46.2542 75.3006 51.7589 72.3888 56.4678C67.9174 63.6988 62.3184 69.3664 55.0328 76.741C53.3624 78.4319 51.6034 80.2124 49.749 82.1221L48.9454 82.9497L48.1035 82.1635C47.0111 81.1433 45.9436 80.1522 44.9027 79.1857C39.2409 73.9288 34.3639 69.4006 30.5325 64.8979C25.9673 59.5326 22.8095 54.1203 21.4819 47.3949C19.4382 37.0417 23.8542 24.2791 35.5116 16.7774Z"
        fill="#C2C2C2"
      />
      <circle opacity="0.5" cx="17.5" cy="75.5" r="1.5" fill="#C2C2C2" />
      <circle opacity="0.5" cx="59.5" cy="1" r="1" fill="#C2C2C2" />
      <circle opacity="0.5" cx="20" cy="5.5" r="1.5" fill="#C2C2C2" />
      <circle opacity="0.5" cx="3" cy="31.5" r="2.5" fill="#C2C2C2" />
      <circle opacity="0.5" cx="82.5" cy="76" r="1" fill="#C2C2C2" />
      <circle opacity="0.5" cx="84.5" cy="21" r="1" fill="#C2C2C2" />
      <circle opacity="0.5" cx="1.5" cy="57" r="1" fill="#C2C2C2" />
      <circle opacity="0.5" cx="91.5" cy="51" r="2" fill="#C2C2C2" />
    </svg>
  );
};

export const openInNewTab = (url) => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};

export const defaultFilterData = {
  dateRange: {
    from: null,
    to: null
  },
  category: [],
  issueRaised: "",
  PCTNo: [],
  status: []
};

export const generateFilterQuery = (filterData, locationData) => {
  let query = [];

  if (!isValidObject(filterData)) {
    return [];
  }

  Object.keys(filterData).forEach((key) => {
    switch (key) {
      case "dateRange":
        const { from, to } = filterData[key];
        if (from && isValidDate(from) && to && isValidDate(to)) {
          query = [
            ...query,
            complaintsQueryPath[key],
            ">=",
            +new Date(`${filterData[key].from}:00:00:00`),
            complaintsQueryPath[key],
            "<=",
            +new Date(`${filterData[key].to}:23:59:59`)
          ];
        }
        break;

      case "PCTNo":
        if (filterData[key] && locationData) {
          let locationIds = [];

          filterData[key].forEach((PCTNo) => {
            const location = Object.values(locationData).find(
              (data) => data.PCTNo === PCTNo
            );
            if (location?.documentId) {
              locationIds.push(location?.documentId);
            }
          });

          if (isValidArray(locationIds)) {
            query = [...query, complaintsQueryPath[key], "in", locationIds];
          }
        }
        break;

      case "issueRaised":
        if (filterData[key].length > 0) {
          query = [
            ...query,
            complaintsQueryPath[key],
            "==",
            `+91${filterData[key]}`
          ];
        }
        break;

      default:
        if (isValidArray(filterData[key]) && filterData[key]) {
          query = [...query, complaintsQueryPath[key], "in", filterData[key]];
        }
        break;
    }
  });

  return query;
};

export const capitalizeFirstLetter = (word) => {
  if (!word) {
    return "N/A";
  }
  const firstLetter = word.charAt(0);

  const firstLetterCap = firstLetter.toUpperCase();

  const remainingLetters = word.slice(1).toLowerCase();

  return firstLetterCap + remainingLetters;
};
